import React, { ReactNode, useState } from 'react';
import { t, Trans } from '@lingui/macro';
import clsx from 'clsx';
import { normaliseLoanDurationRange } from 'components/Signup/helpers/applicationNormalisation';
import { ChecksRequired } from 'components/Signup/ProductOffers/ChecksRequired/ChecksRequired';
import { OffersError } from 'components/Signup/ProductOffers/OffersError/OffersError';
import { OffersLoader } from 'components/Signup/ProductOffers/OffersLoader/OffersLoader';
import sharedStyles from '../TradingHistory.module.css';
import { DocumentRequirements } from './DocumentRequirements/DocumentRequirements';
import { SubmitDocuments } from './SubmitDocuments';
import styles from './TradingHistory.module.css';
import { useDETradingHistoryPage } from './useDETradingHistoryPage/useDETradingHistoryPage';

type TProps = { backButton?: ReactNode };

export const TradingHistoryDE = ({ backButton }: TProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCheckingRequirements, setIsCheckingRequirements] = useState(false);

  const {
    isLoadingPage,
    isLoadingOffersAndRelatedData,
    isSecurityCheckRequired,
    signupError,
    documentRequirements,
    requestedDuration,
  } = useDETradingHistoryPage();

  if (isLoadingOffersAndRelatedData && !isCheckingRequirements) {
    return (
      <div className={sharedStyles.contentWrapper}>
        <OffersLoader />
      </div>
    );
  }

  if (signupError) {
    return (
      <div className={sharedStyles.contentWrapper}>
        <OffersError error={signupError} />
      </div>
    );
  }

  if (isSecurityCheckRequired) {
    return (
      <div className={sharedStyles.contentWrapper}>
        <ChecksRequired />
      </div>
    );
  }
  const loanDuration = normaliseLoanDurationRange(requestedDuration);

  return (
    <>
      {backButton}
      <div className={clsx(sharedStyles.tradingHistory, styles.container)}>
        <div className={sharedStyles.headingContainer}>
          <h1
            data-testid="trading-history-title"
            className={sharedStyles.heading}
          >
            <Trans>Application:</Trans>{' '}
            <strong>{loanDuration || <Trans>loading...</Trans>}</strong>
          </h1>

          <p className={sharedStyles.mainSubHeading}>
            {isLoadingPage
              ? t`Loading your required documents...`
              : t`Add your documents`}
          </p>
        </div>
        {documentRequirements && (
          <DocumentRequirements
            documentRequirements={documentRequirements}
            isSubmitted={isSubmitted}
          />
        )}
        <SubmitDocuments
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
          setIsCheckingRequirements={setIsCheckingRequirements}
        />
      </div>
    </>
  );
};
